<template>
  <section>
    <cover-image :title="'Authors'" :subtitle="'Meet the people behind the platform'" :src="'static/bg-about.jpg'" />
    <div class="container">
      <div class="row">
        <author-card :author="author" class="col-4 author" v-for="author in authors" :key="author"/>
      </div>
    </div>
  </section>
</template>

<script>
import CoverImage from '@/components/ui/CoverImage'
import AuthorCard from '@/components/ui/AuthorCard'
import AuthorsService from '@/services/AuthorsService'

export default {
  name: 'AuthorsView',
  components: {
    CoverImage,
    AuthorCard
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  props: {
    language: String
  },
  data() {
    return {
      authors: null,
      title: this.$t('navigation.authors')
    }
  },
  created() {
    this.getAuthors()
  },
  methods: {
    getAuthors: function() {
      AuthorsService.get(false)
        .then(response => {
          this.authors = response.body
        }, response => {
          console.error(response.body)
        })
    }
  },
  watch: {
    language: function() {
      this.getAuthors()
    }
  }
}
</script>

<style lang="scss" scoped>
  section {
    margin-bottom: 2rem;
  }
</style>



// WEBPACK FOOTER //
// AuthorsView.vue?4d148aac